/**
 * Chart library configuration types
 */

export type ChartLibrary = 'canvasjs' | 'chartjs'

export interface ChartSettings {
  library: ChartLibrary
  canvasjs: {
    theme: 'light1' | 'light2' | 'dark1' | 'dark2'
    animationEnabled: boolean
    exportEnabled: boolean
  }
  chartjs: {
    responsive: boolean
    maintainAspectRatio: boolean
    animation: boolean
    plugins: {
      legend: {
        display: boolean
        position: 'top' | 'bottom' | 'left' | 'right'
      }
      tooltip: {
        enabled: boolean
        intersect: boolean
      }
      zoom: {
        enabled: boolean
        mode: 'x' | 'y' | 'xy'
      }
    }
  }
}

export interface ChartExportOptions {
  format: 'png' | 'pdf' | 'svg'
  filename?: string
  width?: number
  height?: number
  quality?: number
}

export interface ChartLibraryFeatures {
  export: boolean
  zoom: boolean
  pan: boolean
  crosshair: boolean
  realTimeUpdates: boolean
  multiAxis: boolean
  customTooltips: boolean
  bundleSize: string // e.g., "~500KB", "~200KB"
  licensing: 'commercial' | 'open-source'
}

export const CHART_LIBRARY_COMPARISON: Record<ChartLibrary, ChartLibraryFeatures> = {
  canvasjs: {
    export: true,
    zoom: true,
    pan: true,
    crosshair: true,
    realTimeUpdates: true,
    multiAxis: true,
    customTooltips: true,
    bundleSize: '~500KB',
    licensing: 'commercial',
  },
  chartjs: {
    export: true, // via canvas.toDataURL() + jsPDF
    zoom: true, // via chartjs-plugin-zoom
    pan: true, // via chartjs-plugin-zoom
    crosshair: false, // requires custom plugin
    realTimeUpdates: true,
    multiAxis: true,
    customTooltips: true,
    bundleSize: '~200KB',
    licensing: 'open-source',
  },
}

export const DEFAULT_CHART_SETTINGS: ChartSettings = {
  library: 'canvasjs', // Start with current implementation
  canvasjs: {
    theme: 'light2',
    animationEnabled: true,
    exportEnabled: true,
  },
  chartjs: {
    responsive: true,
    maintainAspectRatio: false,
    animation: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        enabled: true,
        intersect: false,
      },
      zoom: {
        enabled: true,
        mode: 'x',
      },
    },
  },
}
